import { render, staticRenderFns } from "./stepInformationBarTH137.vue?vue&type=template&id=4225b2b4&scoped=true"
import script from "./stepInformationBarTH137.vue?vue&type=script&lang=js"
export * from "./stepInformationBarTH137.vue?vue&type=script&lang=js"
import style0 from "./stepInformationBarTH137.vue?vue&type=style&index=0&id=4225b2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4225b2b4",
  null
  
)

export default component.exports